<template>
  <general-layout>
    <template #header>
      <east-operate>
        <template #left>
          <el-button type="success" @click="setState(multipleSelection, true)">
            启用
          </el-button>
          <el-button type="danger" @click="setState(multipleSelection, false)">
            禁用
          </el-button>
        </template>
      </east-operate>
    </template>
    <layui-table
      :data="extensions"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <layui-table-column
        prop="dn"
        width="46"
        type="selection"
      ></layui-table-column>
      <layui-table-column label="名称" width="120">
        <template v-slot="scope">
          <el-button
            style="color: #4d4d4d"
            type="text"
            :disabled="scope.row.disabled"
            @click="editExtension(scope.row.name)"
          >
            {{ scope.row.friendlyName }}
          </el-button>
        </template>
      </layui-table-column>
      <layui-table-column prop="name" label="标识" width="180">
      </layui-table-column>
      <layui-table-column label="简介" min-width="200">
        <template v-slot="scope">
          {{ EXTENSION_INFO[scope.row.name] }}
        </template>
      </layui-table-column>
      <layui-table-column label="状态" width="70" align="center">
        <template v-slot="scope">
          <span v-if="scope.row.disabled" class="text-danger">禁用</span>
          <span v-else class="text-success">启用</span>
        </template>
      </layui-table-column>
      <layui-table-column label="操作" width="180" align="center">
        <template v-slot="scope">
          <el-button
            type="text"
            @click="setState([scope.row], scope.row.disabled)"
            >{{ scope.row.disabled ? "启用" : "禁用" }}</el-button
          >
          <el-button
            :disabled="scope.$index === 0"
            type="text"
            @click="exchange(scope.$index - 1, scope.$index)"
            >上移</el-button
          >
          <el-button
            :disabled="scope.$index === extensions.length - 1"
            type="text"
            @click="exchange(scope.$index, scope.$index + 1)"
            >下移</el-button
          >
          <el-button
            :disabled="scope.row.disabled"
            type="text"
            @click="editExtension(scope.row.name)"
            >配置</el-button
          >
        </template>
      </layui-table-column>
    </layui-table>
  </general-layout>
</template>

<script>
import { mapState } from "vuex";
import UTIL from "@/api/sync/util";
import HOME from "@/api/sync/home";
import EXTENSION_INFO from "@/constant/extensionInfo";

export default {
  data() {
    return {
      EXTENSION_INFO,
      multipleSelection: [],
      extensions: []
    };
  },
  computed: {
    ...mapState(["options", "descriptors"])
  },
  components: {},
  async created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      let response = await UTIL.EXTENSIONS();
      if (response.data.state) {
        this.extensions = response.data.options.extensions;
      }
    },
    async exchange(prevIdx, nextIdx) {
      let prev = this.extensions[prevIdx];
      let next = this.extensions[nextIdx];
      this.$set(this.extensions, prevIdx, next);
      this.$set(this.extensions, nextIdx, prev);
      if (!(await this.save())) {
        this.$set(this.extensions, prevIdx, prev);
        this.$set(this.extensions, nextIdx, next);
      }
    },
    async setState(extensions, state) {
      let oldExtensions = JSON.parse(JSON.stringify(this.extensions));
      extensions.forEach(e => (e.disabled = !state));
      if (!(await this.save())) {
        this.extensions = oldExtensions;
      }
    },
    async save() {
      let response = await HOME.EXTENSION_SETTING({
        options: { extensions: this.extensions }
      });
      if (response.data.state) {
        this.$message.success("扩展设置已更新，重启后生效");
        return true;
      } else {
        return false;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async editExtension(name) {
      this.$router.push({ name: "扩展组件配置", params: { extension: name } });
    }
  }
};
</script>

<style scoped></style>
